import React, { useState, useEffect } from 'react';
import { Container, Form, Button } from 'react-bootstrap';
import { useNavigate, useParams } from "react-router-dom";
import { showToast } from '../config/Alert';
import child from "../assets/images/child.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getChildProfile, addChildProfile, updateChildProfile } from '../services/ProfileApi';
import defaultProfile from "../assets/images/default-profile.png";
import config from '../config/config';
import LoadingSpinner from './LoadingSpinner';

const ChildProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const user = JSON.parse(localStorage.getItem("user"));
  const [childData, setChildData] = useState({
    child_name: "",
    date_of_birth: null,
    gender: "Male",
    profile_image: null,
    previewImage: defaultProfile
  });

  useEffect(() => {
    if (id) fetchChildProfile();
    setLoading(false);
  }, [id]);

  const fetchChildProfile = async () => {
    try {
      setLoading(true);
      const response = await getChildProfile(id);
      setChildData({
        child_name: response.child_name,
        date_of_birth: response.date_of_birth ? new Date(response.date_of_birth) : null,
        gender: response.gender,
        profile_image: response.profile_pic_url || null,
        previewImage: response.profile_pic_url ? config.Image_Base_URL + response.profile_pic_url : defaultProfile
      });
      setLoading(false);
    } catch (error) {
      showToast("Failed to fetch child details", "error");
    }
    finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setChildData({ ...childData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setChildData({ ...childData, profile_image: file, previewImage: URL.createObjectURL(file) });
    }
  };

  const handleDateChange = (date) => {
    setChildData({ ...childData, date_of_birth: date });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!childData.profile_image) {
      showToast("Profile Image is required", "error");
      return;
    }
    setLoading(true);
    const formData = new FormData();
    formData.append("parent_id", user.id);
    formData.append("child_name", childData.child_name);
    formData.append("gender", childData.gender);
    formData.append("date_of_birth", childData.date_of_birth ? childData.date_of_birth.toISOString().split("T")[0] : "");
    if (childData.profile_image && typeof childData.profile_image !== "string") {
      formData.append("profile_image", childData.profile_image);
    }

    try {
      if (id) {
        const response = await updateChildProfile(formData, id);
        showToast("Child profile updated successfully!", "success");
        navigate("/viewChildProfile");
      } else {
        const response = await addChildProfile(formData);
        localStorage.setItem("ChildID", response.child.id);
        navigate("/facilityPlan", { state: { statusKey: "nopayment", subscriptionId: 0 } });
      }
      setLoading(false)
    } catch (error) {
      showToast("Failed to submit child profile", "error");
      setLoading(false)
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className='app-container mobile-bottom'>
      <Container className='mb-3'>
        <Form onSubmit={handleSubmit} className='fs-12'>
          <div className='AccountInnerMain d-flex align-items-center justify-content-between'>
            <h6>
              <img src={child} width={20} alt='user' />
              <span className='ps-1'> Child Profile</span>
            </h6>
            <div className='uploadPic'>
              <div className='photo text-center'>
                <label htmlFor="file-upload" className='image_profile bg_dark_blue custom-file-upload'>
                  <img src={childData.previewImage} alt="Profile Preview" />
                </label>
                <input id="file-upload" type="file" onChange={handleFileChange} />
                <p className='mb-0 fs-10'>Upload Photo *</p>
              </div>
            </div>
          </div>

          <Form.Group className="mb-3">
            <Form.Label>Child Name *</Form.Label>
            <Form.Control type="text" name="child_name" className='border-2 fs-12' autoComplete='off' value={childData.child_name} onChange={handleChange} required />
          </Form.Group>

          <Form.Group className="mb-3 datePicker">
            <Form.Label>Date Of Birth *</Form.Label>
            <DatePicker
              selected={childData.date_of_birth}
              onChange={handleDateChange}
              dateFormat="dd MMM, yyyy"
              showYearDropdown
              showMonthDropdown
              dropdownMode="select"
              className="form-control border-2 fs-12"
              placeholderText="Select Date of Birth"
              isClearable
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Gender *</Form.Label>
            <Form.Select name="gender" className='border-2 form-control fs-12' value={childData.gender} onChange={handleChange}>
              <option>Male</option>
              <option>Female</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="d-flex justify-content-between">
            <Button variant="danger" size='sm' type="submit" className='text-white px-3 rounded-5'>
              {id ? 'Update Child' : 'Add Child'}
            </Button>
          </Form.Group>
          <div className='mt-3 text-danger mb-5'>
            <p className='mb-0 fs-10 fw-6'>Note:</p>
            <small className='fs-10 d-block'>* Please ensure all fields are accurately filled with correct information and proper spelling.</small>
            <small className='fs-10 d-block'>* Uploading a clear, real photo of your child is mandatory. Without a valid photo, certain features, including cafteria purchases, will not be accessible.</small>
          </div>
        </Form>
      </Container>
    </div>
  );
};

export default ChildProfile;